import { DialogM } from "@common/components/alert/dialog/Dialog"
import { IconImageM } from "@common/components/icons/IconsM"
import { useApiStatus } from "@common/hooks/useApiStatus"
import { theme } from "@common/theme/theme"
import { apiIdle, apiRequest } from "@data/redux/actions/api"
import { authService } from "@data/services/authService"
import { liveService } from "@data/services/liveService"
import { substitutionProposalsService } from "@data/services/substitutionProposalsService"
import { capitalize, formatMinutes, readableDayTime } from "@data/utility/Utils"
import SessionTypeBadgeM from "@common/components/badge/SessionTypeBadgeM"
import PillBadgeM from "@common/components/badge/PillBadgeM"
import { useNavigation } from "@react-navigation/native"
import moment from "moment"
import React from "react"
import { View } from "react-native"
import { ActivityIndicator, Divider } from "react-native-paper"
import FontAwesome5 from "react-native-vector-icons/FontAwesome5"
import { connect } from "react-redux"
import live from "../../../assets/icons/generic/live.png"
import StudentsListStringForOccurrence from "./StudentsListStringForOccurrence"
import AvatarM from "../../common/components/avatar/AvatarM"
import FilledButtonM from "../../common/components/button/FilledButtonM"
import TextM from "../../common/components/text/TextM"
import { findClosestNextOccurrence } from "../../student/account/onboarding/LiveRoomCard"

const TutorLiveCardComponent = (props) => {
    const {
        liveSession,
        noButtons = false,
        customTitle = null,
        noAvatars = false,
        style = {},
        oneOccurrence = true,
        navigation = null,
        additionalOnPress = () => {},
        dateTime = null,
    } = props

    const nav = navigation ?? useNavigation()
    const closestNextOccurrence = findClosestNextOccurrence([liveSession])

    const liveMoment = closestNextOccurrence?.date
        ? moment(closestNextOccurrence?.date)
        : null

    const isToday = dateTime
        ? moment(dateTime).isSame(moment(), "day")
        : liveMoment?.isSame(moment(), "day")
    const formattedLiveMoment = dateTime
        ? capitalize(
              moment(dateTime)?.format(
                  (isToday ? "[aujourd'hui]" : "dddd") + " DD MMMM [à] HH:mm"
              )
          )
        : capitalize(
              liveMoment?.format(
                  (isToday && !noButtons ? "[aujourd'hui]" : "dddd") +
                      " [à] HH:mm"
              )
          )

    const isIndividual = liveSession?.live_room?.type === "individual"

    const color = isToday ? theme.colors.success : theme.colors.transparent
    const textColor = isToday ? theme.colors.white : theme.colors.grey
    const studentsListString = liveSession?.students
        ?.map((s) => {
            return s?.display_name + " " + s?.profile?.class
        })
        ?.join(", ")

    const delayToday = liveSession?.delay_today
    const isReplacement = dateTime
        ? liveSession?.next_occurrences?.find((occ) => occ.date === dateTime)
              ?.substitution_id
        : closestNextOccurrence?.substitution_id
    const isRescheduled = dateTime
        ? liveSession?.next_occurrences?.find((occ) => occ.date === dateTime)
              ?.rescheduling_id
        : closestNextOccurrence?.rescheduling_id
    const isAccepted = dateTime
        ? liveSession?.next_occurrences?.find((occ) => occ.date === dateTime)
              ?.substitute_id
        : closestNextOccurrence?.substitute_id

    const renderButton = () => {
        const icon = delayToday
            ? "clock"
            : isReplacement
            ? "retweet"
            : "question-circle"
        const color = delayToday
            ? theme.colors.warning
            : isReplacement
            ? isAccepted
                ? theme.colors.success
                : theme.colors.warning
            : theme.colors.primary
        const text = delayToday
            ? "Retard signalé " + delayToday + " min"
            : isReplacement
            ? isAccepted
                ? "Gérer le rdv"
                : "Remplacement demandé"
            : "GÉRER LES RDV"
        const canCancel = delayToday || (isReplacement && !isAccepted)
        const title = delayToday
            ? `Retard de ${formatMinutes(
                  liveSession?.delay_today
              )} minutes signalé pour la séance de ${formattedLiveMoment}` //lundi 12 sept. 18:00
            : `Demande d'absence ${
                  isAccepted ? "acceptée" : "envoyée"
              } pour la séance de ${formattedLiveMoment}`
        const description = delayToday
            ? "Les élèves seront informés à l'heure de début de live, pour qu'ils commencent à travailler en attendant ton arrivée. Il faudra compenser ce retard en fin de séance !"
            : !isAccepted
            ? "En attente d'acceptation du remplacement par un tuteur"
            : "Le remplacement a été accepté par un tuteur."

        if (!isIndividual && !isToday && !isReplacement && delayToday)
            return <View style={{ height: 50 }}></View>
        if (
            (props.cancelSubstitutionRequest &&
                props.cancelSubstitutionId === isReplacement) ||
            (props.cancelTutorDelayRequest &&
                props.cancelTutorDelayId === liveSession?.id)
        )
            return <ActivityIndicator color={theme.colors.primary} />

        return (
            <FilledButtonM
                color={color}
                mode={"text"}
                style={{ width: null, marginBottom: 0 }}
                onPress={() => {
                    additionalOnPress()
                    if (canCancel) {
                        DialogM.show({
                            text1: title,
                            text2: description,
                            buttonText1: !isAccepted && "Annuler la demande",
                            buttonColor1: theme.colors.error,
                            hideButton1: isAccepted,
                            onPress: () => {
                                if (delayToday) {
                                    const occurrenceDate =
                                        dateTime ??
                                        liveMoment.format("YYYY-MM-DD HH:mm")
                                    props.apiRequest(
                                        substitutionProposalsService.cancelTutorDelay,
                                        { id: liveSession?.id },
                                        {
                                            occurrence_date: occurrenceDate,
                                        }
                                    )
                                } else
                                    props.apiRequest(
                                        substitutionProposalsService.cancelSubstitution,
                                        { id: isReplacement }
                                    )
                            },
                            buttonText2: "Retour",
                        })
                    } else {
                        nav.push("move-session", {
                            liveId: liveSession?.id,
                        })
                    }
                }}
                fontWeight={"Bold"}
                labelStyle={{
                    fontSize: 10,
                    marginHorizontal: 10,
                    marginVertical: 5,
                }}
                contentStyle={{ height: 40 }}
                label={text}
                icon={() => (
                    <FontAwesome5
                        name={icon}
                        solid
                        color={theme.colors.primary}
                        size={16}
                    />
                )}
            />
        )
    }

    useApiStatus(
        substitutionProposalsService.cancelTutorDelay,
        false,
        false,
        () => {
            props.apiRequest(authService.getUser)
            props.apiRequest(liveService.getLiveSessions)
        }
    )

    return (
        <View
            style={{
                borderRadius: 10,
                overflow: "hidden",
                marginVertical: 10,
                borderColor: theme.colors.lightMore,
                backgroundColor: theme.colors.white,
                borderWidth: 1,
                width: "100%",
                ...style,
            }}
        >
            <View
                style={{
                    backgroundColor: color,
                    paddingHorizontal: 10,
                    paddingVertical: 8,
                    flexDirection: "row",
                    alignItems: "center",
                    borderColor: theme.colors.lightMore,
                    borderBottomWidth: 1,
                }}
            >
                <View style={{ flexDirection: "row", alignItems: "center", flexShrink: 1 }}>
                    <IconImageM
                        source={live}
                        width={22}
                        style={{
                            tintColor: textColor,
                        }}
                    />
                    <TextM
                        fontWeight={"SemiBold"}
                        color={textColor}
                        fontSize={14}
                        style={{ marginLeft: 5, flexShrink: 1 }}
                        wrap
                    >
                        {customTitle
                            ? customTitle
                            : capitalize(
                                  oneOccurrence
                                      ? moment(dateTime ?? liveMoment).format(
                                            "dddd DD MMM [à] HH:mm"
                                        ) +
                                            (isRescheduled ? " *" : "") +
                                            (isReplacement ? " **" : "") +
                                            " - " +
                                            formatMinutes(liveSession?.duration)
                                      : readableDayTime(
                                            liveSession?.day_time,
                                            liveSession?.duration
                                        )
                              )}
                    </TextM>
                </View>
            </View>
            <View style={{ paddingHorizontal: 10, paddingTop: 14 }}>
                {!customTitle && (isRescheduled || isReplacement) && (
                    <TextM
                        fontWeight={"light"}
                        fontSize={10}
                        style={{
                            marginTop: -6,
                            marginBottom: 6,
                        }}
                    >
                        {isRescheduled ? "*Replanifié " : ""}
                        {isReplacement ? "**Remplacement " : ""}
                    </TextM>
                )}
                <StudentsListStringForOccurrence
                    liveSession={liveSession}
                    occurrence={closestNextOccurrence}
                    forceDisplayName
                    style={{
                        marginBottom: 14,
                    }}
                />
                <View style={{ flexDirection: "row", alignItems: "center", marginBottom: 10 }}>
                    {!noAvatars && studentsListString?.length > 0 && (
                        <>
                            {liveSession?.students?.map((s, index) => {
                                return (
                                    <AvatarM
                                        key={index}
                                        size={30}
                                        user={s}
                                        style={{
                                            borderRadius: 25,
                                            borderRightWidth: 5,
                                            borderColor: theme.colors.white,
                                            marginLeft: index !== 0 ? -15 : 0,
                                            zIndex:
                                                liveSession?.students?.length -
                                                index,
                                        }}
                                    />
                                )
                            })}
                            <View
                                style={{
                                    width: 1,
                                    height: 16,
                                    backgroundColor: theme.colors.lightMore,
                                    marginHorizontal: 10,
                                }}
                            />
                        </>
                    )}
                    <SessionTypeBadgeM type={liveSession?.live_room?.type} />
                    {/* The live's space — sent only to a tutor who works in
                        several, on every live, so the others see no change.
                        A long school name ends in « … » inside the card. */}
                    {!!liveSession?.space_label && (
                        <PillBadgeM
                            label={liveSession.space_label}
                            color={theme.colors.warning}
                            backgroundColor={theme.colors.warningLight}
                            style={{ marginLeft: 6, flexShrink: 1 }}
                        />
                    )}
                </View>
            </View>
            {!noButtons && <Divider style={{ width: "100%" }} />}
            {!noButtons && (
                <View
                    style={{
                        flexDirection: "row",
                        justifyContent: "space-between",
                        alignItems: "center",
                    }}
                >
                    {renderButton()}
                    <FilledButtonM
                        style={{
                            width: null,
                            marginBottom: 0,
                            marginRight: 10,
                        }}
                        mode={isToday ? "contained" : "text"}
                        contentStyle={{ height: 32 }}
                        labelStyle={{ fontSize: 10 }}
                        label="GO !"
                        onPress={() => {
                            additionalOnPress()
                            if (isToday) {
                                nav.push("pre-call", {
                                    liveSessionId: liveSession?.id,
                                })
                            } else {
                                DialogM.show({
                                    champion: "zoe",
                                    variant: "main",
                                    text1: "Le live n'est accessible que le jour-même",
                                    text2: `Reviens ${liveMoment.format(
                                        "dddd"
                                    )} pour te connecter !`,
                                })
                            }
                        }}
                        color={
                            isToday ? theme.colors.success : theme.colors?.grey
                        }
                    />
                </View>
            )}
        </View>
    )
}
const mapStateToProps = (state) => {
    return {
        user: state.data.currentUser?.object,
        getUserRequest: state.api.getUser?.request,
        schoolSubjects: state.data.staticData?.school_subjects,
        cancelSubstitutionRequest: state.api.cancelSubstitution?.request,
        cancelSubstitutionId: state.api.cancelSubstitution?.routeParams?.id,
        cancelTutorDelayRequest: state.api.cancelTutorDelayRequest?.request,
        cancelTutorDelayId: state.api.cancelTutorDelayRequest?.routeParams?.id,
        supportWhatsappUrl: state.data.staticData?.support_whatsapp_url,
    }
}

const mapDispatchToProps = {
    apiRequest,
    apiIdle,
}

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(TutorLiveCardComponent)
